import app from '@core/configApp.ts'
import { createHead } from '@unhead/vue'

const head = createHead()

app.use(head)
